import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

const QUERY_KEY = 'spoofing';

interface SpoofingResponse {
	success: string;
	result: {
		is_spoofing: boolean;
		is_demoing: boolean;
	};
}

export const useSpoofing = () => {
	const http = useHttpClient('v2');
	const { data, isLoading } = useQuery([QUERY_KEY], () => http.get<SpoofingResponse>('/spoofing'), {
		select: (data) => data.data.result,
		refetchInterval: Infinity,
	});
	return {
		isSpoofing: data?.is_spoofing,
		isDemoing: data?.is_demoing,
		isLoading,
	};
};
